// ** React Imports
import { useMemo } from "react";

// ** Custom Components
import Text from "components/typography/Text";
import MenuItem from "components/layout/Menu/Item";
import Block from "components/layout/Block";
import Checkbox from "components/layout/Checkbox";

// #####################################################

const MenuItemContent = ({
	item,
	selected,
	menuFontSize,
	isMultiple,
	customInput,
	withAdditionalInfo,
}) => {
	const isSelected = useMemo(() => {
		if (isMultiple) {
			return selected.includes(item.value);
		} else {
			return item.value === selected;
		}
	}, [selected, isMultiple]);

	// #####################################################

	return (
		<MenuItem.Content $customPadding={"0.5rem 1rem"}>
			<Block flex flexWrap fullWidth>
				<Block
					flex
					justifyBetween
					fullWidth
					style={
						item.justifyEndContent && {
							flexDirection: "row-reverse",
						}
					}
				>
					<Text
						bold={
							isSelected ||
							((selected === null || selected === undefined) &&
								item.empty)
						}
						size={menuFontSize ?? "1rem"}
						style={
							customInput ? { overflowWrap: "anywhere" } : null
						}
					>
						{typeof item.content === "function"
							? item.content()
							: item.content}
					</Text>
					{isMultiple && <Checkbox checked={isSelected} readOnly />}
					{item.justifyEndContent && !isMultiple && (
						<Text
							bold={
								isSelected ||
								((selected === null ||
									selected === undefined) &&
									item.empty)
							}
							size={menuFontSize ?? "1rem"}
							style={
								customInput
									? { overflowWrap: "anywhere" }
									: null
							}
						>
							{item.justifyEndContent}
						</Text>
					)}
				</Block>
				{withAdditionalInfo && item.tooltip && (
					<Block fullWidth>
						<Text small muted block>
							{item.tooltip}
						</Text>
					</Block>
				)}
			</Block>
		</MenuItem.Content>
	);
};

export default MenuItemContent;

// #####################################################
